import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar/Sidebar'
import Textbox from '../Textbox/Textbox'
import Calender from '../Calender/Calender'
import SelectButton from '../SelectButton/SelectButton'
import TextArea from '../TextArea/TextArea'
import TableComponent from '../TableComponent/TableComponent'
import Tax_SelectButton from '../Tax_SelectButton/Tax_SelectButton'
import html2pdf from 'html2pdf.js';
import PopUp from '../PopUp/PopUp'

const Invoice = () => {
  const [discountAndTax, setDiscountAndTax] = useState(['On Total', 'On Line'])
  const [taxes, setTaxes] = useState([
    { taxType: 'No Tax', rate: 0 },
    { taxType: 'VAT', rate: 5 },
    { taxType: 'GST', rate: 5 },
    { taxType: 'GST', rate: 12 },
    { taxType: 'GST', rate: 18 },
    { taxType: 'GST', rate: 28 }
  ])
  const [items, setItems] = useState([])
  const [subTotal, setSubTotal] = useState(0)
  const [discount, setdiscount] = useState(0)
  const [taxPercentage, setTaxPercentage] = useState(0)
  const [taxName, setTaxName] = useState('No Tax')
  const [date, setDate] = useState('')
  const [onTotal, setOnTotal] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [note, setNote] = useState('')
  const [imageUrl, setImageUrl] = useState(null)

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0]
    setDate(today)
  }, [])


  const [invoiceDetails, setInVoiceDetails] = useState({
    title: 'Tax Invoice',
    invoice: 'INV-001',
    currency: '\u20B9',
    date: `${date}`,
    invoiceFrom: '',
    invoiceTo: ''
  })

  //function passing to get items data from table component

  const handleItemChange = (updatedItems) => {
    setItems(updatedItems)
  }

  //function for calculating subtotal
  const calculateSubtotal = () => {
    let total = 0
    items.forEach((val) => {
      total = total + val.total
    })
    setSubTotal(total)
  }

  useEffect(() => {
    calculateSubtotal()
  }, [items])

  // useEffect(() => {
  //   console.log(taxPercentage)
  // },[taxPercentage])


  const generatePDF = () => {
    if (!invoiceDetails.title || !invoiceDetails.invoice || !imageUrl || !invoiceDetails.currency || !invoiceDetails.invoiceFrom || !invoiceDetails.invoiceTo) {
      alert("Please fill out all required fields.")
      return
    }

    if (items.length === 0) {
      alert("Please add at least one item to the invoice.");
      return
    }
    const invoiceHTML = `
        <div style="font-family: Arial, sans-serif; padding: 20px;border:1px solid black">
          <h1 style="text-align: center;margin-top:20px">Tax Invoice</h1>
          <div style='display: flex;justify-content: space-between'>
            <div>
              <strong>Title:</strong> ${invoiceDetails.title} <br />
              <strong>Invoice No:</strong> ${invoiceDetails.invoice} <br />
              <strong>Date:</strong> ${date} <br />
            </div>
            <img src=${imageUrl} alt="Sample Image" height="100" width="150" />
          </div>
          <div style='display: flex;justify-content: space-between;margin-top:50px'>
                <div style='display: flex'>
                  <strong>Invoice From:</strong> <span>${invoiceDetails.invoiceFrom} </span>
                </div>
                <div style='display: flex'>
                  <strong>Invoice To:</strong> <span>${invoiceDetails.invoiceTo}</span>
                </div>
          </div>
          
          <hr />
  
          <h2 style="text-align: center;">Items</h2>
           <table style="width: 100%; border-collapse: collapse; margin-top: 20px; font-family: Arial, sans-serif; background-color: #f9f9f9;">
            <thead>
                <tr style="background-color: #D3D3D3; color: black; text-align: center;">
                <th style="border: 1px solid #ddd; padding: 12px; font-weight: bold;">Description</th>
                <th style="border: 1px solid #ddd; padding: 12px; font-weight: bold;">Quantity</th>
                <th style="border: 1px solid #ddd; padding: 12px; font-weight: bold;">Rate</th>
                ${onTotal ? `<th style="border: 1px solid #ddd; padding: 12px; font-weight: bold;">Discount</th>` : ''}
                ${onTotal ? `<th style="border: 1px solid #ddd; padding: 12px; font-weight: bold;">Tax</th>` : ''}
                <th style="border: 1px solid #ddd; padding: 12px; font-weight: bold;">Total</th>
                </tr>
            </thead>
            <tbody>
                ${items.map(item => `
                <tr style="text-align: center; background-color: ${item.index % 2 === 0 ? '#f1f1f1' : '#ffffff'}; border-bottom: 1px solid #ddd;">
                    <td style="border: 1px solid #ddd; padding: 12px; text-align: left; padding-left: 20px;">${item.description}</td>
                    <td style="border: 1px solid #ddd; padding: 12px;">${item.quantity}</td>
                    <td style="border: 1px solid #ddd; padding: 12px;">${invoiceDetails.currency}${item.rate}.00</td>
                    ${onTotal ? `<td style="border: 1px solid #ddd; padding: 12px;">${item.discount}</td>` : ''}
                    ${onTotal ? `<td style="border: 1px solid #ddd; padding: 12px;">${item.taxKey}-${item.taxPercentage}%</td>` : ''}
                    <td style="border: 1px solid #ddd; padding: 12px;">${invoiceDetails.currency}${item.total}.00</td>
                </tr>
                `).join('')}
            </tbody>
          </table>
  
          <hr />
  
          <div  style="display: flex; flex-direction: column; justify-content: flex-end; margin-top: 20px; align-items: flex-end;">
            <strong>Subtotal:</strong> ${invoiceDetails.currency}${subTotal.toFixed(2)} <br />
            ${onTotal ? '' : `  <strong>Discount:</strong> ${invoiceDetails.currency}${((discount / 100) * subTotal).toFixed(2)} <br />`}
            ${onTotal ? '' : `  <strong>Tax:</strong> ${invoiceDetails.currency}${((taxPercentage / 100) * subTotal).toFixed(2)} <br />`}
            ${onTotal ? '' : `  <strong>Total:</strong> ${invoiceDetails.currency}${((subTotal + taxPercentage) - (discount / 100) * subTotal).toFixed(2)} <br />`}
          </div>
          <div style="display: flex;gap:20px">
          <strong>Note:</strong>${note} 
          </div>
        </div>
      `;

    // Use html2pdf to generate and download the PDF
    const options = {
      margin: 15,  // Increased margin for better content spacing
      filename: 'invoice.pdf',
      image: {
        type: 'jpeg',
        quality: 1  // Maximum image quality
      },
      html2canvas: {
        scale: 8, // Increase scale for higher resolution canvas (adjust based on your needs)
        logging: true, // Set to true for debug output (optional)
        letterRendering: true // Improve text rendering
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait',
        compress: true // Optional: reduce the file size while maintaining quality
      }
    };

    html2pdf()
      .from(invoiceHTML)
      .set(options)
      .save();


  }

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      convertToBase64(file)
    }
  };

  // Convert file to base64
  const convertToBase64 = (file) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      setImageUrl(reader.result); // Set base64 encoded image URL
    };
    reader.onerror = (error) => {
      console.error('Error converting image:', error);
    };
  };



  return (
    <div className='container-fluid'>
      <div className="row">
        <div className='col-2 d-none d-md-block sidebar'>
          <Sidebar />
        </div>
        <div className='col-10 bg-white h-auto p-3 '>
          <div className='right-part'>
            <div className='d-flex justify-content-center align-items-center'>
              {
                imageUrl && (
                  <img src={imageUrl} alt="CompanyLogo" className='LogoImage' />
                )
              }
            </div>
            <div className='d-flex justify-content-center align-items-center gap-3 flex-wrap mt-2'>
              <div>
                <label style={{ cursor: 'pointer' }} className='image_label'>
                  <img
                    src='/upload.png'
                    alt="Upload Icon"
                    style={{ height: '20px', width: '20px' }}
                  />
                  <input
                    type="file"
                    accept="image/*"
                    className='d-none'
                    onChange={handleImageChange}
                  />
                  <p className='mt-3'>Company Logo</p>
                </label>
              </div>


              <div className='d-flex flex-column gap-1'><label className='ms-2'>Title</label><Textbox height='50' width='200' value={invoiceDetails.title} setValue={(val) => setInVoiceDetails((prev) => ({ ...prev, title: val }))} /></div>
              <div className='d-flex flex-column gap-1'><label className='ms-2'>Invoice</label><Textbox height='50' width='200' value={invoiceDetails.invoice} setValue={(val) => setInVoiceDetails((prev) => ({ ...prev, invoice: val }))} /></div>
              <div className='d-flex flex-column gap-1'><label className='ms-2'>Currency</label><Textbox height='50' width='200' value={invoiceDetails.currency} setValue={(val) => setInVoiceDetails((prev) => ({ ...prev, currency: val }))} /></div>
            </div>
            <div className='d-flex justify-content-center align-items-center gap-3 flex-wrap mt-3'>
              <div className='d-flex flex-column gap-1'><label className='ms-2'>Date</label><Calender setValue={(val) => setInVoiceDetails((prev) => ({ ...prev, date: val }))} /></div>
              <div className='d-flex flex-column gap-1'><label className='ms-2'>Discount and Tax</label><SelectButton values={discountAndTax} setOnTotal={setOnTotal} height='50' width='200' /></div>
              {
                onTotal ?
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Taxes</label><div className='d-flex'>{onTotal ? <button onClick={openModal}>+</button> : null}<Tax_SelectButton values={taxes}
                    setTaxPercentage={(val) => setTaxPercentage(val)} closeModal={closeModal} setTaxName={(val) => setTaxName(val)}
                    taxPercentage={taxPercentage} taxName={taxName}
                    height='50' width='200' border='0' />
                  </div></div>
                  :
                  null
              }
            </div>
            <div className='d-flex justify-content-center align-items-center gap-3 flex-wrap mt-3'>
              <div className='d-flex flex-column gap-1'><label className='ms-2'>Invoice From</label><TextArea placeholder='Seller Name and Address' setValue={(val) => setInVoiceDetails((prev) => ({ ...prev, invoiceFrom: val }))} /></div>
              <div className='d-flex flex-column gap-1'><label className='ms-2'>Invoice To</label><TextArea placeholder='Buyer Name and Address' setValue={(val) => setInVoiceDetails((prev) => ({ ...prev, invoiceTo: val }))} /></div>
              <div className='d-flex flex-column gap-1'><label className='ms-2'>Note</label><TextArea placeholder='Any Invoice Notes' setValue={(val) => setNote(val)} /></div>
            </div>

            <div className='d-flex justify-content-center align-items-center'>
              <TableComponent onItemChange={handleItemChange}
                onTotal={onTotal} values={taxes} setTaxPercentage={(val) => setTaxPercentage(val)} setTaxName={(val) => setTaxName(val)}
                taxPercentage={taxPercentage} taxName={taxName}
              />
            </div>

            <div className="d-flex flex-column align-items-end gap-1 align-items-xs-center">
              {
                onTotal ?
                  null
                  :
                  <div className='d-flex flex-wrap justify-content-center align-items-center'>
                    <div className='d-flex'>
                      <button onClick={openModal}>+</button><Tax_SelectButton values={taxes}
                        closeModal={closeModal} setTaxPercentage={(val) => setTaxPercentage(val)}
                        taxPercentage={taxPercentage} taxName={taxName}
                        setTaxName={(val) => setTaxName(val)} height='50' width='170' border='0' />
                    </div>
                    <div className='d-flex'>
                      <button>%</button><Textbox height='50' width='170' border='0' setValue={(val) => setdiscount(val)} />
                    </div>
                  </div>
              }
              <div className="table-responsive">
                <table className="table-bordered" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  {
                    onTotal ? null :
                      <>
                        <tr style={{ height: '50px' }}>
                          <td style={{ width: '210px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'right' }}>
                            Subtotal
                          </td>
                          <td style={{ width: '210px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>
                            {invoiceDetails.currency}{subTotal}
                          </td>
                        </tr>
                        <tr style={{ height: '50px' }}>
                          <td style={{ width: '100px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'right' }}>
                            Discount
                          </td>
                          <td style={{ width: '100px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>
                            - {invoiceDetails.currency}{(((discount / 100) * subTotal).toFixed(2))}
                          </td>
                        </tr>
                        <tr style={{ height: '50px', width: '100px' }}>
                          <td style={{ width: '100px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'right' }}>
                            Tax:{taxName}
                          </td>
                          <td style={{ width: '100px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>
                            +{(invoiceDetails.currency)} {((taxPercentage / 100) * subTotal).toFixed(2)}
                          </td>
                        </tr>
                      </>
                  }
                  <tr style={{ height: '50px' }}>
                    <td style={{ width: '100px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'right' }}>
                      Total
                    </td>
                    <td style={{ width: '100px', height: '50px', border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>
                      {
                        onTotal ?
                          <span>
                            {invoiceDetails.currency}{subTotal.toFixed(2)}
                          </span>
                          :
                          <span>
                            {invoiceDetails.currency}{(
                              (Number(subTotal) - (Number(discount) / 100) * Number(subTotal)) +
                              (Number(taxPercentage) / 100) * (Number(subTotal) - (Number(discount) / 100) * Number(subTotal))
                            ).toFixed(2)}
                          </span>
                      }
                    </td>
                  </tr>
                </table>
              </div>
              <button onClick={generatePDF} className='print'>Print</button>
            </div>
          </div>
        </div>
      </div>
      <PopUp isOpen={isModalOpen} closeModal={closeModal} taxes={taxes} setTaxes={setTaxes} />
    </div>
  )
}

export default Invoice
